import React, { useState, useEffect } from "react";
import { Link, useHistory } from 'react-router-dom';
import MaterialTable from "@material-table/core";
import { Modal } from 'react-bootstrap';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import dualdot from '../../../images/dual-dot.png';
import visa from '../../../images/visa 1.png';
import eye from '../../../images/Eye.png';
import eyeoff from '../../../images/Eye off.png';

import Loader from '../../pages/Loader';
import axios from 'axios';
import Snackbars from '../../pages/Snackbars';
import card1 from '../../../images/card/v-card.png';
import jsPDF from 'jspdf';
import { CsvBuilder } from 'filefy';
import 'jspdf-autotable';
import { checkauhtoken } from '../../../api/PrePageLoad';
import validator from 'validator';
import { useTranslation } from "react-i18next";
import { gtmTrackCardCreated } from '../../../utils/gtm';
import { fbqTrackCardCreated } from '../../../utils/meta';
import { ttqTrackCardCreated } from '../../../utils/tiktok';

const settings = {
    dots: false,
    infinite: false,
    arrows: false,
    loop: false,
    merge: true,
    center: true,
    autoWidth: true,

    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
        {
            breakpoint: 991,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,

            },
        },
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 2,
                centerMode: true,

            },
        },
        {
            breakpoint: 600,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
            },
        },
    ],
};


export const MyCards = () => {
    const { t } = useTranslation();
  
    const [cvvVisibility, setCVV] = useState({});
    const [selectedCardId, setSelectedCardId] = useState(null);

    // Add this function to toggle CVV for individual cards
    const toggleCVV = (cardId) => {
      // If currently hidden, require 2FA to show
      if (!cvvVisibility[cardId]) {
        setSelectedCardId(cardId); // Save the card to show CVV after verification
        setGoogleAuthenticator(true);
      } else {
        // If currently visible, just hide without 2FA
        setCVV(prev => ({
          ...prev,
          [cardId]: false
        }));
      }
    };
    
    
    const history = useHistory();
    const [authcode, setauthcode] = useState("");
    const [authcode_error, setauthcode_error] = useState("");
    const [error, setError] = useState(false);
    const [error_msg, setErrorMsg] = useState("");
    const [success, setSuccess] = useState(false);
    const [success_msg, setSuccessMsg] = useState("");
    const [accountval, setaccountval] = useState("");
    const [amountval, setamountval] = useState("");
    const [cardidval, setcardidval] = useState("");
    const [accountidval, setaccountidval] = useState("");
    const [amountsymbole, setamountsymbole] = useState("");

    const [AddCard, setAddCard] = useState(false);
    const [loader, setLoader] = useState(false);
    const [cardarray, setcardarray] = useState([]);
    const [cardarrayoriginal, setcardarrayoriginal] = useState(["aaa"]);

    const [OTPVerification, setOTPVerification] = useState(false);
    const [GoogleAuthenticator, setGoogleAuthenticator] = useState(false);


    const [TransferAccept, setTransferAccept] = useState(false);
    const [TransferDecline, setTransferDecline] = useState(false);
    const [success_display_debit_amount, setsuccess_display_debit_amount] = useState("");
    const [success_display_card_number, setsuccess_display_card_number] = useState("");
    const [success_display_from_account, setsuccess_display_from_account] = useState("");
    const [success_display_refno, setsuccess_display_refno] = useState("");
    const [success_display_details, setsuccess_display_details] = useState("");

    const [error_display_details, seterror_display_details] = useState("");
    const [error_display_amount, seterror_display_amount] = useState("");

    useEffect(() => {
        checkauhtoken();
        handleAccounts();
        handleVendorDetails();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const validateAuthcode = (value) => {
        setauthcode(value);
        if (!validator.isEmpty(value)) {
            setauthcode_error("");
            return true;
        } else {
            setauthcode_error("Enter 6 digit google authetication code");
            return false;
        }
    }
    const authsubmit = () => {
      if (validateAuthcode(authcode) === false) {
        setauthcode_error("Enter 6 digit google authetication code");
        return false;
    } 
      let jsonpar = {
        authcode: authcode,
    }
    const headers = {
        'Content-Type': 'application/json',
        'useraccesstoken': process.env.REACT_APP_USER_ACCESS_TOKEN,
        'userauthtoken': 'Bearer ' + window.sessionStorage.getItem("user_jwt"),
    }
    setLoader(true);
    setGoogleAuthenticator(false);
    axios.post(process.env.REACT_APP_API_URL + 'cards/verify2FA', jsonpar, { headers: headers })
        .then(async function (res) {
            res = await res.data;
            if (res.code === "200") {
              if (selectedCardId) {
                setCVV(prev => ({
                  ...prev,
                  [selectedCardId]: true
                }));
                setSelectedCardId(null);
              }
                setauthcode("")
                setLoader(false);
            } else {
              setauthcode("")
              setError(true);
              setErrorMsg(res.message);
              setTimeout(() => {
                  setError(false);
              }, 6000);
              setLoader(false);
            }
        })
        .catch(function (error) {
          setError(true);
          setErrorMsg(t('ERROR_MSG.SOMETHING'));
          setTimeout(() => {
              setError(false);
          }, 6000);
          setLoader(false);
        });
    }
    
    const [accountarray, setaccountarray] = useState([]);

    const handleAccounts = () => {
        const headers = {
            'Content-Type': 'application/json',
            'useraccesstoken': process.env.REACT_APP_USER_ACCESS_TOKEN,
            'userauthtoken': 'Bearer ' + window.sessionStorage.getItem("user_jwt"),
        }
        setLoader(true);
        axios.get(process.env.REACT_APP_API_URL + 'account/getuseraccoundsbyid', { headers: headers })
            .then(function (res) {
                res = res.data;
                if (res.code === "200") {
                    console.log(res.data)
                    let newArray = [];
                    res.data.forEach(element => {
                      if(element.account_currency_type =="USD"){
                        newArray.push(element);
                      }
                      if(element.account_currency_type =="EUR"){
                        newArray.push(element);
                      }
                    });
                    handleLoad(newArray);
                } else {
                    setTimeout(() => {
                        setLoader(false);
                    }, 1000);
                }
            })
            .catch(function (error) {
                setTimeout(() => {
                    setLoader(false);
                }, 1000);
            });
    }

    const [EURFee, setEURFee] = useState("");
    const [USDFee, setUSDFee] = useState("");
    const [EURMinBlc, setEURMinBlc] = useState("");
    const [USDMinBlc, setUSDMinBlc] = useState("");
    const handleVendorDetails = () => {
        const headers = {
            'Content-Type': 'application/json',
            'useraccesstoken': process.env.REACT_APP_USER_ACCESS_TOKEN,
            'userauthtoken': 'Bearer ' + window.sessionStorage.getItem("user_jwt"),
        }
        setLoader(true);
        axios.get(process.env.REACT_APP_API_URL + 'cards/vendorDetails', { headers: headers })
            .then(function (res) {
                res = res.data;
                if (res.code === "200") { 
                    console.log(res.data)
                    setEURFee(parseFloat(res.data.eurAccount.bins[0].fees.issueFee));
                    setUSDFee(parseFloat(res.data.usdAccount.bins[0].fees.issueFee));
                    setEURMinBlc(parseFloat(res.data.eurAccount.bins[0].fees.minCardBalance));
                    setUSDMinBlc(parseFloat(res.data.usdAccount.bins[0].fees.minCardBalance));
                } else {
                    setTimeout(() => {
                        setLoader(false);
                    }, 1000);
                }
            })
            .catch(function (error) {
                setTimeout(() => {
                    setLoader(false);
                }, 1000);
            });
    }

    const handleLoad = async (accountsData) => {
    
        const headers = {
            'Content-Type': 'application/json',
            'useraccesstoken': process.env.REACT_APP_USER_ACCESS_TOKEN,
            'userauthtoken': 'Bearer ' + window.sessionStorage.getItem("user_jwt"),
        }
        setLoader(true);
        axios.get(process.env.REACT_APP_API_URL + 'cards/getusercards', { headers: headers })
            .then(async function (res) {
                res = await res.data;

                if (res.code === "200") {
                    setLoader(false);
                    await setcardarrayoriginal(res.data);

                    const filteredAccounts = accountsData.filter(
                        acc => !res.data.some(c => c.card_currancy === acc.account_currency_type)
                    );

                    
                    const sortedCurrencies = filteredAccounts.sort((a, b) => {
                      const order = ['eur', 'usd'];
                      return order.indexOf(a.account_currency_type.toLowerCase()) - order.indexOf(b.account_currency_type.toLowerCase());
                      });

                    setaccountarray(sortedCurrencies);

                    if (res.data.length > 0) {
                        let TempArrswap = [];
                        res.data.forEach(element => {
                            let action = "";
                            let status = <Link to="#" className="btn btn-outline-warning btn-rounded">Pending</Link>;
                            if (element.usercard_status === "Approved") {
                                 status = <Link to="#" onClick={() => handleapprove(element.card_id)} className="btn btn-outline-success btn-rounded">Pay Card Fees</Link>;
                            } else if (element.usercard_status === "Active") {
                                 status = <Link to="#" className="btn btn-outline-success btn-rounded">Active</Link>;
                                 action = <div><Link to={"/card-settings/" + element.card_id} className="btn btn-primary btn-rounded btn-xs"><i className="fa fa-solid fa-gear"></i></Link></div>;
                            } else if (element.usercard_status === "Blocked") {
                                 status = <Link to="#" className="btn btn-outline-danger btn-rounded">Blocked</Link>;
                                 action = <div><Link to={"/card-settings/" + element.card_id} className="btn btn-primary btn-rounded btn-xs"><i className="fa fa-solid fa-gear"></i></Link></div>;
                            }
                            else if (element.usercard_status === "Rejected") {
                                 status = <Link to="#" className="btn btn-outline-danger btn-rounded">Pay Card Fees</Link>;
                            }

                            let cardno = "";
                            let validno = "";
                            if (element.usercard_status === "Active") {
                                cardno = element.card_number;
                                validno = element.exp_month + "/" + element.exp_year;
                            }

                            let swaptemp = {
                                CardName: element.card_name,
                                Currency: element.card_currancy,
                                CardNumber: formatCardNumber(Number(cardno)),
                                Validthru: validno,
                                Action: action,
                                Status: status,
                                StatusText: element.usercard_status,
                            };
                            TempArrswap.push(swaptemp);

                        });
                        setcardarray(TempArrswap);
                    }
                   
                } else {
                    setLoader(false);
                }
            })
            .catch(function (error) {
                setLoader(false);
            });
    }

    const handleapprove = (card_id) => {

        let jsonpar = {
            card_id: card_id,
        }
        const headers = {
            'Content-Type': 'application/json',
            'useraccesstoken': process.env.REACT_APP_USER_ACCESS_TOKEN,
            'userauthtoken': 'Bearer ' + window.sessionStorage.getItem("user_jwt"),
        }
        setLoader(true);
        axios.post(process.env.REACT_APP_API_URL + 'cards/getapprovecarddetails', jsonpar, { headers: headers })
            .then(async function (res) {
                res = await res.data;
                if (res.code === "200") {
                    setaccountval(res.data.accno);
                    setamountval(res.data.amount);
                    setamountsymbole(res.data.amountsymbole);
                    setaccountidval(res.data.accid);
                    setcardidval(res.data.cardid);
                    setOTPVerification(true);
                    setLoader(false);
                } else {
                    setLoader(false);
                }
            })
            .catch(function (error) {
                setLoader(false);
            });
    }

    const handleissue = () => {

        let jsonpar = {
            card_id: cardidval,
            acc_id: accountidval,
            amount_id: amountval,
        }
        const headers = {
            'Content-Type': 'application/json',
            'useraccesstoken': process.env.REACT_APP_USER_ACCESS_TOKEN,
            'userauthtoken': 'Bearer ' + window.sessionStorage.getItem("user_jwt"),
        }
        setLoader(true);
        setOTPVerification(false);
        axios.post(process.env.REACT_APP_API_URL + 'cards/submitissuetra', jsonpar, { headers: headers })
            .then(async function (res) {
                res = await res.data;
                if (res.code === "200") {
                    setsuccess_display_debit_amount(res.data.success_display_debit_amount);
                    setsuccess_display_card_number(res.data.success_display_card_number);
                    setsuccess_display_from_account(res.data.success_display_from_account);
                    setsuccess_display_refno(res.data.success_display_refno);
                    setsuccess_display_details(res.data.success_display_details);
                    setTransferAccept(true);

                    setaccountval("");
                    setamountval("");
                    setamountsymbole("");
                    setaccountidval("");
                    setcardidval("");
                    handleLoad();
                    setLoader(false);
                } else {
                    seterror_display_details(res.data.error_display_details);
                    seterror_display_amount(res.data.error_display_amount);
                    setTransferDecline(true);
                    setLoader(false);
                }
            })
            .catch(function (error) {
                setLoader(false);
            });
    }

    const handleChangeCSVNdPDF = (val) => {
        let FileName = "Card List";

        let columns = [
            { title: 'Card Name', field: 'CardName' },
            { title: 'Card Number', field: 'CardNumber' },
            { title: 'Valid thru', field: 'Validthru' },
            { title: 'Currency', field: 'Currency' },
            { title: 'Status', field: 'StatusText' },
        ];

        const columnTitles = columns.map(columnDef => columnDef.title);

        const FileData = cardarray.map(rowData =>
            [rowData["CardName"],
            rowData["CardNumber"],
            rowData["Validthru"],
            rowData["Currency"],
            rowData["StatusText"],]
            
        );
        if (val === "CSV") {
            const builder = new CsvBuilder(FileName + `.csv`)
                .setColumns(columnTitles)
                .addRows(FileData)
                .exportFile();

            return builder;
        }
        else if (val === "PDF") {
            const doc = new jsPDF();

            doc.autoTable({
                head: [columnTitles],
                body: FileData,
            });

            doc.save(FileName + `.pdf`);
        }
    }




    const [select_account, setselect_account] = useState("");
    const [select_account_error, setselect_account_error] = useState("");
    const [title, setTitle] = useState("");
    const [title_error, setTitle_error] = useState("");
    const [select_account_currency, setselect_account_currency] = useState("");

    const validateAccount = (value) => {
      let currency ;
      accountarray.forEach(element => {
        if(element.account_id_pk == value){
          currency = element.account_currency_type
        }
      });
        setselect_account(value);
        setselect_account_currency(currency);
        if (!validator.isEmpty(value)) {
            setselect_account_error("");
            return true;
        } else {
            setselect_account_error("Select Your Account");
            return false;
        }
    }

    const validateTitle = (value) => {
        setTitle(value);
        if (!validator.isEmpty(value)) {
            setTitle_error("");
            return true;
        } else {
            setTitle_error("Enter Card Name");
            return false;
        }
    }
   
    const handlesubmit = () => {
        if ( validateAccount(select_account) === false) {
            setselect_account_error("Select Your Account");
            return false;
        }else if (validateTitle(title) === false) {
            setselect_account_error("");
            setTitle_error("Enter Card Name");
            return false;
        }else {
            setTitle_error("");
            setLoader(true);
            setAddCard(false);

            let jsonpar = {
                title: title,
                account: select_account,
            }
            const headers = {
                'Content-Type': 'application/json',
                'useraccesstoken': process.env.REACT_APP_USER_ACCESS_TOKEN,
                'userauthtoken': 'Bearer ' + window.sessionStorage.getItem("user_jwt"),
            }
            axios.post(process.env.REACT_APP_API_URL + 'cards/submitvirtual', jsonpar, { headers: headers })
                .then(function (res) {
                    res = res.data;
                    if (res.code === "200") {
                        // Track card created
                        gtmTrackCardCreated({
                          card_type: 'virtual', // 'virtual' or 'physical'
                          card_number: res.data.card_number,
                          card_currancy: res.data.card_currancy
                        });
                        fbqTrackCardCreated({
                          card_type: 'virtual', // 'virtual' or 'physical'
                          card_number: res.data.card_number,
                          card_currancy: res.data.card_currancy
                        });
                        ttqTrackCardCreated({
                          card_type: 'virtual', // 'virtual' or 'physical'
                          card_number: res.data.card_number,
                          card_currancy: res.data.card_currancy
                        });

                        setSuccess(true);
                        setSuccessMsg(res.message);
                        setTimeout(() => {
                            setSuccess(false);
                        }, 6000);
                        handleAccounts();
                        setAddCard(false)
                        setTitle("");
                        setselect_account("");
                    } else {
                        setError(true);
                        setErrorMsg(res.message);
                        setTimeout(() => {
                            setError(false);
                        }, 6000);
                        setLoader(false);
                    }
                })
                .catch(function (error) {
                    setError(true);
                    setErrorMsg("Oops! Something went wrong");
                    setLoader(false);
                });
        }
    }

    const formatCardNumber = (number) => {
        if (!number) return '';
        return number
        .toString()
        .replace(/\s+/g, '')
        .match(/.{1,4}/g)
        ?.join(' ') || '';
    };


    return (
      <>
        {error ? (
          <Snackbars open_close={error} type="error" message={error_msg} />
        ) : (
          ""
        )}
        {success ? (
          <Snackbars
            open_close={success}
            type="success"
            message={success_msg}
          />
        ) : (
          ""
        )}
            {/* <p> We're actively upgrading our platform. If you face any issues, please be assured our team is addressing them promptly.</p> */}

        <div className="card bg-0 bg-none">
          <div className="card-header page-title-space mobile-card-header">
            <h2 className="text-black font-w500 mb-0">My Cards</h2>
            {accountarray.length > 0 ? (
              <div className="mobileFullWidth">
                <Link
                  to="#"
                  onClick={() => setAddCard(true)}
                  className="btn btn-primary btn-rounded"
                >
                  + &nbsp;Add Card
                </Link>
              </div>
            ) : (
              ""
            )}
          </div>
        </div>
        {loader === true ? (
          <div>
            <Loader open_close={loader} />
          </div>
        ) : (
          <div>
            <div className="row">
              <div className="col-lg-12 csmt-card">
              <div className="main-card">
                {cardarrayoriginal.map((data, index) => (
                  <div className="card-box">
                    <div className="card-name-type">
                      <p className="card-type-name">{data.card_name}</p>
                      <img src={visa} alt="" className="card-type" />
                    </div>
                    <div className="card-number">
                      <p>{formatCardNumber(Number(data.card_number))}</p>
                    </div>
                    <div className="card-name-type">
                      <div className="card-info">
                        <p className="card-exp-title">Exp Date</p>
                        <p className="card-exp-date">{data.exp_month}/{data.exp_year}</p>
                      </div>
                      <div className="card-info">
                            <p className="card-exp-title">CVV</p>
                            <p className="card-exp-date">
                                <span>{cvvVisibility[data.card_number] ? data.cvv_number : '***'}{' '}</span>
                                <img 
                                    src={cvvVisibility[data.card_number] ? eyeoff : eye} 
                                    alt="toggle cvv" 
                                    className="cvv-hide" 
                                    onClick={() => toggleCVV(data.card_number)} 
                                    style={{ cursor: 'pointer' }}
                                />
                            </p>
                        </div>
                      <div className="card-name-type">
                        <p className="card-holder-name">{data.card_customer_name}</p>
                        <p className="card-holder-balance">{data.card_currancy === "USD"
                              ? "$ " + data.total_available
                              : "€ " + data.total_available}
                        </p>
                      </div>
                    </div>
                  </div>
                ))}
                </div>
              </div>

            </div>

            <div className="row">
              <div className="col-sm-12">
                <div className="card height-cstm-chart table-action-center">
                  <div className="card-body">
                    <div className="table-responsive">
                      {cardarray.length > 0 ? (
                        <MaterialTable
                          title="Card List"
                          columns={[
                            { title: "Card Name", field: "CardName" },
                            { title: "Card Number", field: "CardNumber" },
                            { title: "Valid thru", field: "Validthru" },
                            { title: "Currency", field: "Currency" },
                            { title: "Action", field: "Action" },
                            {
                              title: "Status",
                              field: "Status",
                              align: "center",
                            },
                          ]}
                          data={cardarray}
                          options={{
                            exportMenu: [
                              {
                                label: "Export PDF",
                                exportFunc: (cols, datas) =>
                                  handleChangeCSVNdPDF("PDF"),
                              },
                              {
                                label: "Export CSV",
                                exportFunc: (cols, datas) =>
                                  handleChangeCSVNdPDF("CSV"),
                              },
                            ],
                            paging: true,
                            pageSize: 5,
                            pageSizeOptions: [5, 10, 15],
                            emptyRowsWhenPaging: false,
                          }}
                        />
                      ) : (
                        <div className="d-sm-flex d-block border-0 pb-0">
                          <div className="pr-3 mr-auto mb-sm-0 mb-3 nofoundFullWidth">
                            <h4 className="fs-20 text-black mb-1 nofoundTitle">
                              Card List Overview
                            </h4>
                            <span className="fs-12 nofoundText">
                              No Data Found
                            </span>
                          </div>
                        </div>
                      )}

                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        <Modal className="modal fade" show={TransferAccept}>
          <div className="modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h3 className="modal-title">Card Issuance Fee Payment</h3>
                <button
                  type="button"
                  className="close"
                  onClick={() => setTransferAccept(false)}
                >
                  <span>&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <div className="check">
                  <i class="fa fa-solid fa-check"></i>
                  <p className="fs-14 mb-1 Submitted">Transaction Submitted</p>
                </div>

                <div className="row">
                  <div className="col-md-12 mb-1">
                    <p className="fs-16 mb-1">
                      Debited Amount :{" "}
                      <span className="text-black">
                        {success_display_debit_amount}
                      </span>
                    </p>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-12 mb-1">
                    <p className="fs-16 mb-1">
                      Card Number :{" "}
                      <span className="text-black">
                        {success_display_card_number}
                      </span>
                    </p>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-12 mb-1">
                    <p className="fs-16 mb-1">
                      Debited Account Number :{" "}
                      <span className="text-black">
                        {success_display_from_account}
                      </span>
                    </p>
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-12 mb-1">
                    <p className="fs-16 mb-1">
                      Reference Number :{" "}
                      <span className="text-black">
                        {success_display_refno}
                      </span>
                    </p>
                  </div>
                </div>

                <div className="row mt-1">
                  <div className="col-md-12 mb-3">
                    <p className="fs-16 mb-1">Details</p>
                    <span className="text-black">
                      {success_display_details}
                    </span>
                  </div>
                </div>
                <div className="row mt-3 mb-2">
                  <ul className="btm-link">
                    <li>
                      <Link to="#" onClick={() => setTransferAccept(false)}>
                        {" "}
                        OK{" "}
                      </Link>
                    </li>
                    <li>
                      <Link to="/dashboard"> Dashboard</Link>
                    </li>
                    <li>
                      <Link to="#" onClick={() => setTransferAccept(false)}>
                        {" "}
                        Card List
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </Modal>

        <Modal className="modal fade" show={TransferDecline}>
          <div className="modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h3 className="modal-title">Card Issuance Fee Payment</h3>
                <button
                  type="button"
                  className="close"
                  onClick={() => setTransferDecline(false)}
                >
                  <span>&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <div className="check">
                  <i class="fa fa-solid fa-times"></i>
                  <p className="fs-14 mb-1 Submitted">Transaction Failed</p>
                </div>

                <div className="row">
                  <div className="col-md-12 mb-1">
                    <p className="fs-16 mb-1">
                      Amount :{" "}
                      <span className="text-black">{error_display_amount}</span>
                    </p>
                  </div>
                </div>

                <div className="row mt-1">
                  <div className="col-md-12 mb-3">
                    <p className="fs-16 mb-1">Details</p>
                    <span className="text-black">{error_display_details}</span>
                  </div>
                </div>
                <div className="row mt-3 mb-2">
                  <ul className="btm-link">
                    <li>
                      <Link to="#" onClick={() => setTransferDecline(false)}>
                        {" "}
                        Retry{" "}
                      </Link>
                    </li>
                    <li>
                      <Link to="/dashboard"> Dashboard</Link>
                    </li>
                    <li>
                      <Link to="#" onClick={() => setTransferDecline(false)}>
                        {" "}
                        Card List
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </Modal>

        <Modal className="modal fade" show={AddCard}>
          <div className="modal-dialog-centered ">
            <div className="modal-content">
              <div className="modal-header">
                <h3 className="modal-title">Add Card</h3>
              </div>
              <div className="modal-body">
                {/* <div className="items p-3">
                                    <div className="card-bx mb-0">
                                        <img src={card1} alt="" className="w-100" />
                                        <div className="card-info text-white">
                                            <p className="mb-1">Alinkos Card</p>
                                            <div className="d-flex align-items-center justify-content-between mb-sm-5 mb-3">
                                                <img src={dualdot} alt="" className="dot-img" />
                                                <h4 className="fs-19 text-white mb-0">{"**** **** **** " + String(1234).slice(-4)}</h4>
                                            </div>
                                            <div className="d-flex">
                                                <div className="mr-5">
                                                    <p className="fs-14 mb-1 op6">VALID THRU</p>
                                                    <span>01/2030</span>
                                                </div>
                                                <div>
                                                    <p className="fs-14 mb-1 op6">CARD HOLDER</p>
                                                    <span>Name</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div> */}

                <div className="form-group mb-2 fullWidth">
                  <label className="mb-1 fullWidth">Select Account</label>
                  <div className="form-group position-relative">
                    <select
                      className="form-control"
                      onChange={(e) => validateAccount(e.target.value)}
                      value={select_account}
                    >
                      <option value="">Select Account</option>
                      {accountarray &&
                        accountarray.map((row) => (
                          <option
                            value={row.account_id_pk}
                            key={row.account_id_pk}
                          >
                            My Account : {row.account_number} ({" "}
                            {row.account_currency_type} )
                          </option>
                        ))}
                    </select>
                  </div>
                  {select_account_error !== "" ? (
                    <label className="text-red">{select_account_error}</label>
                  ) : (
                    ""
                  )}
                </div>

                <div className="form-group mb-2 fullWidth">
                  <label className="mb-1 fullWidth">Card Name</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter Card Name"
                    onChange={(e) => validateTitle(e.target.value)}
                    value={title}
                  />
                  {title_error !== "" ? (
                    <label className="text-red">{title_error}</label>
                  ) : (
                    ""
                  )}
                </div>

               {select_account && (
                <div className="form-group mb-2 fullWidth">

                  <div className="d-flex justify-content-between mb-2">
                    <label className="mb-0">Issue Fee :</label>
                    <span>
                      {select_account_currency === "EUR" ? EURFee +" EUR" : USDFee +" USD"}
                    </span>
                  </div>

                  <div className="d-flex justify-content-between mb-2">
                    <label className="mb-0">Minimum Card Balance :</label>
                    <span>
                      {select_account_currency === "EUR" ? EURMinBlc +" EUR": USDMinBlc +" USD"}
                    </span>
                  </div>

                  <div className="d-flex justify-content-between fw-bold">
                    <label className="mb-0">Total :</label>
                    <span>
                      {select_account_currency === "EUR"
                        ? (EURFee + EURMinBlc) +" EUR"
                        : (USDFee + USDMinBlc) +" USD"}
                    </span>
                  </div>

                </div>
              )}



              </div>
              <div className="modal-footer">
                <Link
                  to="#"
                  onClick={handlesubmit}
                  className="btn btn-primary btn-rounded"
                >
                  Add Card
                </Link>
                {/* <Link to="#"  onClick={setAddCard(false)} className="btn btn-outline-light ml-3 btn-rounded">Cancel</Link> */}
                <button
                  type="button"
                  className="btn btn-outline-light ml-3 btn-rounded"
                  onClick={() => setAddCard(false)}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </Modal>
        <Modal className="modal fade" show={GoogleAuthenticator}>
            <div className="modal-dialog-centered " >
                <div className="modal-content">
                    <div className="modal-header">
                        <h3 className="modal-title">Google Authenticator</h3>
                        <button type="button" className="close" onClick={() => setGoogleAuthenticator(false)}><span>&times;</span>
                        </button>
                    </div>
                    <div className="modal-body">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="form-group">
                                    <label className="mb-2 ">Google Authenticator Code</label>
                                    <input type="text" maxLength="6" className="form-control text-black" placeholder="Please Enter Google Authenticator Code" onChange={(e) => validateAuthcode(e.target.value)} value={authcode} />
                                    {authcode_error !== "" ? <label className='text-red'>{authcode_error}</label> : ""}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="modal-footer">
                        <button className="btn btn-light btn-rounded light" onClick={() => setGoogleAuthenticator(false)}>Close</button>
                        <Link to="#" onClick={authsubmit} className="btn btn-primary btn-rounded">Submit</Link>
                  
                    </div>
                </div>
            </div>
        </Modal>
      </>
    );

}
export default MyCards;